import React from 'react';
import {useEffect, useState} from 'react';
import {Container, Form, Grid, Loader} from 'semantic-ui-react';
import ThingsToDoCards from './ThingsToDoCards';
import ThingsToDoFilter from './ThingsToDoFilter';
import REST from 'go/requests/rest';
import {Redirect} from 'react-router';
import {connect} from 'react-redux';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import _ from 'lodash';
import {
  extractOrgIdsFromPermissions,
  extractSubOrgIdsFromPermissions,
  isRecipient,
  canViewAndContinueSubapplication,
  checkThingsToDoRoles,
} from 'go/security/permissions';
import {getSubOrganizationId} from 'common/utils';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';

export const ThingsToDo = (props) => {
  const {token} = props;
  // default filters as parameter to useState
  const [filters, setFilters] = useState({});
  const [thingsToDo, setThingsToDo] = useState([]);
  const [redirect, setRedirect] = useState(null);
  const [currentOrg] = useState({});
  // filter options will populate the select dropdowns
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    // an external user can have multiple orgs, how can they see things from all their orgs here?
    const orgIds = extractOrgIdsFromPermissions(props.permissions);
    let orgsList = [];
    _.forEach(orgIds, (org) => {
      if (checkThingsToDoRoles(props.permissions, org)) {
        orgsList.push(org);
      }
    });
    const orgId = orgsList[0];
    let subOrgIds = extractSubOrgIdsFromPermissions(props.permissions);
    if (_.isEmpty(subOrgIds)) subOrgIds = orgsList;

    REST.search
      .getRecipientToDoList(token, {
        organizationId: orgId,
        organizationIds: orgsList,
        subOrganizationIds: subOrgIds,
        limit: 1000,
        offset: 0,
      })
      .then(REST.handler.handleResponse)
      .then(async (data) => {
        setThingsToDo(data.items);
        determineFilterOptions(data.items);
        return;
      })
      .catch(async (error) => {
        console.error('error getting recipient to do list');
        if (canViewAndContinueSubapplication(props.permissions)) {
          REST.dynamicData
            .getSubapplicationsByToken(token)
            .then(REST.handler.handleResponse)
            .then(async (data) => {
              setThingsToDo(data);
              determineFilterOptions(data);
            })
            .catch((err) => {
              console.error('Request for subapplication data failed.');
            });
        }
      });
  }, []);

  const determineFilterOptions = async (thingsToDo) => {
    let foNameOptions = [];
    let recipientOptions = [];
    let subRecipientOptions = [];
    let disasterTypeOptions = [];
    let statusOptions = [];
    let statusId = 1;
    let orgFilterId = 0;
    let subOrgFilterId = 0;
    let disasterFilterId = 0;
    _.forEach(thingsToDo, (item) => {
      let pushFO = true;
      let pushRecipient = true;
      let pushSubRecipient = true;
      let pushDisaster = true;
      let pushStatus = true;
      if (item.fundingOpportunityId && _.size(foNameOptions) > 0) {
        _.forEach(foNameOptions, (fo) => {
          if (fo.id === item.fundingOpportunityId) {
            pushFO = false;
          }
        });
        if (pushFO) {
          foNameOptions.push({
            id: item.fundingOpportunityId,
            name: item.fundingOpportunityName,
          });
        }
      } else if (item.fundingOpportunityId) {
        foNameOptions.push({
          id: item.fundingOpportunityId,
          name: item.fundingOpportunityName,
        });
      }
      if (item.organizationName && _.size(recipientOptions) > 0) {
        _.forEach(recipientOptions, (recipient) => {
          if (recipient.name === item.organizationName) {
            pushRecipient = false;
          }
        });
        if (pushRecipient) {
          recipientOptions.push({
            id: item.organizationId ? item.organizationId : orgFilterId,
            name: item.organizationName,
          });
          orgFilterId = orgFilterId + 1;
        }
      } else if (item.organizationName) {
        recipientOptions.push({
          id: item.organizationId ? item.organizationId : orgFilterId,
          name: item.organizationName,
        });
        orgFilterId = orgFilterId + 1;
      }
      if (item.subOrganizationName && _.size(subRecipientOptions) > 0) {
        _.forEach(subRecipientOptions, (subRecipient) => {
          if (subRecipient.name === item.subOrganizationName) {
            pushSubRecipient = false;
          }
        });
        if (pushSubRecipient) {
          subRecipientOptions.push({
            id: getSubOrganizationId(item) ? getSubOrganizationId(item) : subOrgFilterId,
            name: item.subOrganizationName,
          });
          subOrgFilterId = subOrgFilterId + 1;
        }
      } else if (item.subOrganizationName) {
        subRecipientOptions.push({
          id: getSubOrganizationId(item) ? getSubOrganizationId(item) : subOrgFilterId,
          name: item.subOrganizationName,
        });
        subOrgFilterId = subOrgFilterId + 1;
      }
      if (item.disasterInfo && _.size(disasterTypeOptions) > 0) {
        _.forEach(disasterTypeOptions, (disaster) => {
          if (disaster.name === item.disasterInfo) {
            pushDisaster = false;
          }
        });
        if (pushDisaster) {
          disasterTypeOptions.push({
            id: disasterFilterId,
            name: item.disasterInfo,
          });
          disasterFilterId = disasterFilterId + 1;
        }
      } else if (item.disasterInfo) {
        disasterTypeOptions.push({
          id: disasterFilterId,
          name: item.disasterInfo,
        });
        disasterFilterId = disasterFilterId + 1;
      }
      if (item.status && _.size(statusOptions) > 0) {
        _.forEach(statusOptions, (status) => {
          if (status.name === item.status) {
            pushStatus = false;
          }
        });
        if (pushStatus) {
          statusOptions.push({
            id: statusId,
            name: item.status,
          });
          statusId = statusId + 1;
        }
      } else if (item.status) {
        statusOptions.push({
          id: statusId,
          name: item.status,
        });
        statusId = statusId + 1;
      }
    });
    const foOptions = _.reverse(
      _.map(foNameOptions, (fo) => ({
        key: fo.id,
        value: fo.id,
        text: fo.name,
      }))
    );
    const recipients = _.reverse(
      _.map(recipientOptions, (rec) => ({
        key: rec.id,
        value: rec.name,
        text: rec.name,
      }))
    );
    const subRecipients = _.reverse(
      _.map(subRecipientOptions, (subRec) => ({
        key: subRec.id,
        value: subRec.name,
        text: subRec.name,
      }))
    );
    const disasterOptions = _.reverse(
      _.map(disasterTypeOptions, (disaster) => ({
        key: disaster.id,
        value: disaster.name,
        text: disaster.name,
      }))
    );
    let statuses = _.reverse(
      _.map(statusOptions, (status) => ({
        key: status.id,
        value: status.name,
        text: ASSOCIATED_ENTITY_STATUSES[status.name],
      }))
    );
    statuses = [{key: 0, value: '', text: ''}, ...statuses];
    await setFilterOptions({
      fundingOpportunityNames: foOptions,
      recipients: recipients,
      subRecipients: subRecipients,
      disasterTypes: disasterOptions,
      status: statuses,
    });
    return;
  };

  return redirect ? (
    <Redirect push to={redirect} />
  ) : (
    <Main>
      <Container fluid>
        <Grid
          key="thingsToDoGrid"
          doubling
          stackable
          reversed="mobile"
          padded="vertically"
        >
          <Grid.Row key="thingsToDoPageTitle">
            <Grid.Column width={4}>
              <h4>Things To Do</h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row key="orgGrants">
            <Grid.Column width={4}>
              <ThingsToDoFilter
                filters={filters}
                setFilters={setFilters}
                filterOptions={filterOptions}
              />
            </Grid.Column>
            {
              /*loading condition*/ false ? (
                <Grid.Column width={12}>
                  <Loader inline="centered" active content="Loading" />
                </Grid.Column>
              ) : (
                <ThingsToDoCards
                  token={token}
                  currentOrg={currentOrg}
                  thingsToDo={thingsToDo}
                  filters={filters}
                  setRedirect={setRedirect}
                  props={props}
                />
              )
            }
          </Grid.Row>
        </Grid>
      </Container>
    </Main>
  );
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps)(ThingsToDo);
